import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Timeline.css';

const Timeline = ({ entries, receivedDate }) => {
  const navigate = useNavigate();

  const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(dateStr + 'T00:00:00'); // Avoid timezone offset
    return date.toLocaleDateString('en-US', options);
  };

  // Sort entries by DatePlaced ascending; if equal, sort by EntryID ascending.
  const sortedEntries = entries.slice().sort((a, b) => {
    const dateA = new Date(a.DatePlaced);
    const dateB = new Date(b.DatePlaced);
    if (dateA < dateB) return -1;
    if (dateA > dateB) return 1;
    return a.EntryID - b.EntryID;
  });

  // Handler: navigate to a location entry’s detail page
  const handleClick = (entryID) => {
    // Adjust this route to match your actual detail page route
    navigate(`/view-location-entry/${entryID}`);
  };

  return (
    <div>
      <h2>Item Journey</h2>
      <div className="timeline-container">
        {/* "Item Received" - not clickable since it has no EntryID */}
        <div className="timeline-line"></div>
        <div className="timeline-item timeline-received">
          <div className="timeline-date">{formatDate(receivedDate)}</div>
          <div className="timeline-content">
            <div className="timeline-label">📦 Item Received</div>
          </div>
        </div>

        {/* Intermediate items */}
        {sortedEntries.slice(0, -1).map((entry) => (
          <div className="timeline-item" key={entry.EntryID}>
            <div className="timeline-date">{formatDate(entry.DatePlaced)}</div>
            <div
              className="timeline-content clickable"
              onClick={() => handleClick(entry.EntryID)}
            >
              <div className="timeline-location">{entry.Location}</div>
            </div>
          </div>
        ))}

        {/* Last item (current location) */}
        {sortedEntries.length > 0 && (
          <div
            className="timeline-item timeline-current"
            key={sortedEntries[sortedEntries.length - 1].EntryID}
          >
            <div className="timeline-date">
              {formatDate(sortedEntries[sortedEntries.length - 1].DatePlaced)}
            </div>
            <div
              className="timeline-content clickable"
              onClick={() =>
                handleClick(sortedEntries[sortedEntries.length - 1].EntryID)
              }
            >
              <div className="timeline-label">
                📍 Current Location: {sortedEntries[sortedEntries.length - 1].Location}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Timeline;
